import AboutUs from "../layout/aboutUs";
import Banner from "../layout/banner";
import Footer from "../layout/footer";
import ImageCarousel from "../layout/imageCarousel";
import ShopValues from "../layout/shopValues";
import VideoSection from "../layout/video";

function HomePage() {
    return (
        <div>
            < Banner />
            < AboutUs />
            < ShopValues />
            < ImageCarousel />
            < VideoSection />
            < Footer />
        </div>
    )
}

export default HomePage;